





import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class SkipDelayCount extends Vue {
  @Prop({ default: 0 })
  private skipDelayCountNum!: number;

  private created() {}

  private mounted() {}
}
